"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _tracing = require("@sentry/tracing");

var _ErrorRank = _interopRequireDefault(require("./ErrorRank"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context3, _context4; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(source), !0)).call(_context3, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var makeErrorService = function makeErrorService(_ref) {
  var sentryInit = _ref.sentryInit,
      sentryClientOptions = _ref.sentryClientOptions,
      configureScope = _ref.configureScope,
      captureException = _ref.captureException,
      _ref$integrations = _ref.integrations,
      integrations = _ref$integrations === void 0 ? [] : _ref$integrations,
      lastEventId = _ref.lastEventId,
      _ref$enableBrowserTra = _ref.enableBrowserTracing,
      enableBrowserTracing = _ref$enableBrowserTra === void 0 ? false : _ref$enableBrowserTra;

  var init = function init(_ref2) {
    var dsn = _ref2.dsn,
        version = _ref2.version,
        _ref2$environment = _ref2.environment,
        environment = _ref2$environment === void 0 ? 'development' : _ref2$environment,
        _beforeSend = _ref2.beforeSend,
        browserTracing = _ref2.browserTracing,
        tracesSampleRate = _ref2.tracesSampleRate,
        tracesSampler = _ref2.tracesSampler,
        ignoreErrors = _ref2.ignoreErrors,
        dist = _ref2.dist,
        _ref2$shouldUseLocalS = _ref2.shouldUseLocalSentryInstance,
        shouldUseLocalSentryInstance = _ref2$shouldUseLocalS === void 0 ? false : _ref2$shouldUseLocalS,
        shouldBypassAdBlocker = _ref2.shouldBypassAdBlocker;

    if (!dsn) {
      throw new Error("[universe]: Please provide a valid Sentry DSN");
    }

    if (!version) {
      throw new Error("[universe]: Please provide the app's version");
    }

    if ((0, _typeof2["default"])(browserTracing) === 'object' && (browserTracing === null || (0, _isArray["default"])(browserTracing))) {
      throw new Error("[universe]: browserTracing can't be null or an array, please provide a valid object.");
    }

    if (shouldUseLocalSentryInstance && typeof sentryClientOptions === 'undefined') {
      throw new Error("[universe]: You can initialize local Sentry instances for web apps only.");
    }

    var sentryIntegrations = integrations;

    if (enableBrowserTracing) {
      var _context;

      sentryIntegrations = (0, _concat["default"])(_context = []).call(_context, (0, _toConsumableArray2["default"])(sentryIntegrations), [new _tracing.BrowserTracing(browserTracing)]);
    }

    var sentryInitParameters = {
      dsn: dsn,
      release: version,
      dist: dist,
      environment: environment,
      ignoreErrors: ignoreErrors,
      beforeSend: function beforeSend(initialEvent, hint) {
        var event = initialEvent; // run a custom beforeSend

        if (typeof _beforeSend === 'function') {
          event = _beforeSend(event, hint);

          if (event === null) {
            // do not capture error if custom beforeSend returns null
            return null;
          }
        }

        return event;
      },
      integrations: sentryIntegrations,
      tracesSampleRate: tracesSampleRate,
      tracesSampler: tracesSampler
    };

    if (shouldBypassAdBlocker) {
      sentryInitParameters.tunnel = 'https://app-metrics.razorpay.com';
    }

    if (shouldUseLocalSentryInstance) {
      var _context2;

      var defaultIntegrations = sentryClientOptions.defaultIntegrations,
          defaultStackParser = sentryClientOptions.defaultStackParser,
          makeFetchTransport = sentryClientOptions.makeFetchTransport,
          SentryClient = sentryClientOptions.SentryClient,
          SentryHub = sentryClientOptions.SentryHub,
          sentryMakeMain = sentryClientOptions.sentryMakeMain;
      sentryInitParameters.integrations = (0, _concat["default"])(_context2 = []).call(_context2, (0, _toConsumableArray2["default"])(defaultIntegrations), (0, _toConsumableArray2["default"])(sentryIntegrations));
      sentryInitParameters.stackParser = defaultStackParser;
      sentryInitParameters.transport = makeFetchTransport;
      var sentryClient = new SentryClient(sentryInitParameters);
      var sentryHub = new SentryHub(sentryClient);
      var oldHub = sentryMakeMain(sentryHub);
      return {
        sentryHub: sentryHub,
        oldHub: oldHub
      };
    }

    sentryInit(sentryInitParameters);
  };

  var captureError = function captureError(error) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      rank: _ErrorRank["default"].P3,
      tags: {},
      extra: {}
    },
        rank = _ref3.rank,
        tags = _ref3.tags,
        extra = _ref3.extra,
        sentryHub = _ref3.sentryHub;

    var captureExceptionParameters = {
      extra: extra,
      tags: _objectSpread(_objectSpread({}, tags), {}, {
        rank: rank
      })
    };

    if (sentryHub) {
      // The hub.run method makes sure that Sentry.getCurrentHub() returns this hub during the callback
      sentryHub.run(function (currentHub) {
        currentHub.captureException(error, captureExceptionParameters);
      });
    } else {
      captureException(error, captureExceptionParameters);
    }
  };

  var setUserContext = function setUserContext(_ref4) {
    var userId = _ref4.userId,
        _ref4$tags = _ref4.tags,
        tags = _ref4$tags === void 0 ? {} : _ref4$tags,
        sentryHub = _ref4.sentryHub;

    var configureScopeParameter = function configureScopeParameter(scope) {
      if (userId) {
        scope.setUser({
          id: userId
        });
      }

      for (var _i = 0, _Object$entries = (0, _entries["default"])(tags); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        scope.setTag(key, value);
      }
    };

    if (sentryHub) {
      // The hub.run method makes sure that Sentry.getCurrentHub() returns this hub during the callback
      sentryHub.run(function (currentHub) {
        currentHub.configureScope(configureScopeParameter);
      });
    } else {
      configureScope(configureScopeParameter);
    }
  };

  var sentryLastEventId = lastEventId;
  return {
    init: init,
    captureError: captureError,
    setUserContext: setUserContext,
    ErrorRank: _ErrorRank["default"],
    lastEventId: function lastEventId(sentryHub) {
      if (sentryHub) {
        return sentryHub.lastEventId();
      }

      return sentryLastEventId();
    }
  };
};

var _default = makeErrorService;
exports["default"] = _default;